import { Training } from '@/app/entities/Training'
import { Button } from '@/view/components/ui/button'
import { Dialog } from '@/view/components/ui/dialog'

import { Edit, Trash } from 'iconsax-react'
import { ChevronLeft, PlusCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { TrainingForm } from '../../components/training-form/TrainingForm'
import { TrainingFormValues } from '../../hooks/useTrainingForm'
import { useDeleteTrainingContext } from '../../providers/DeleteTrainingProvider'
import { useTrainingFormContext } from '../../providers/TraningFormProvider'
import { DeleteTraining } from './DeleteTraining'

interface TrainingDetailsHeaderProps {
  training: Training
}

const parseTrainingFormValues = (training: Training): TrainingFormValues => {
  return {
    _id: training?._id || '',
    name: training?.name || '',
    description: training?.description || '',
    isSellersApp: training?.isSellersApp || false,
    isTeamsApp: training?.isTeamsApp || false,
  }
}

export const TrainingDetailsHeader = ({
  training,
}: TrainingDetailsHeaderProps) => {
  const { isCreateTrainingModalOpen, setIsCreateTrainingModalOpen } =
    useTrainingFormContext()

  const { isDeleteTrainingModalOpen, setIsDeleteTrainingModalOpen } =
    useDeleteTrainingContext()

  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/conteudos/gerenciar?tab=training')
  }

  const handleOpenCreateTrainingModal = () => {
    setIsCreateTrainingModalOpen(true)
  }

  const handleOpenDeleteTrainingModal = () => {
    setIsDeleteTrainingModalOpen(true)
  }

  const handleNewClass = () => {
    navigate(`/conteudos/gerenciar/treinamentos/${training?._id}/new`)
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full"
          onClick={handleBack}
        >
          <ChevronLeft size={24} className="mr-2" />
        </Button>
        <h1 className="text-2xl font-semibold">{training?.name}</h1>
      </div>
      <div className="mt-8 flex w-full items-center justify-between">
        <h2 className="text-xl font-semibold">Conteúdo</h2>
        <div className="flex items-center gap-2">
          <Button
            size="icon"
            variant="outline"
            className="h-11 w-11"
            onClick={handleOpenDeleteTrainingModal}
          >
            <Trash size={20} />
          </Button>
          <Button
            className="rounded-full text-white"
            size="lg"
            onClick={handleNewClass}
          >
            <PlusCircle size={20} className="mr-2" />
            Nova Aula
          </Button>
          <Button
            className="rounded-full"
            size="lg"
            variant="outline"
            onClick={handleOpenCreateTrainingModal}
          >
            <Edit size={24} className="mr-2" strokeWidth={1.5} />
            Editar treinamento
          </Button>
        </div>
      </div>
      <Dialog
        open={isCreateTrainingModalOpen}
        onOpenChange={setIsCreateTrainingModalOpen}
      >
        <TrainingForm defaultValues={parseTrainingFormValues(training)} />
      </Dialog>

      <Dialog
        open={isDeleteTrainingModalOpen}
        onOpenChange={setIsDeleteTrainingModalOpen}
      >
        <DeleteTraining trainingId={training?._id} />
      </Dialog>
    </>
  )
}
